const MetaDataOrder = () => import('Views/metaDataOrder/index');
const PendingReviewOrder = () => import('Views/metaDataOrder/pending-review-order');
const ReviewedOrderList = () => import('Views/metaDataOrder/reviewed-order-list');
const DataUseApply = () => import('Views/metaDataOrder/data-useApply-new-ui');
const DataApplyList = () => import('Views/metaDataOrder/data-apply-list-new-ui');
const DataApplyDetail = () => import('Views/metaDataOrder/data-apply-detail-new-ui');
const OrderDetail = () => import('Views/metaDataOrder/order-detail-new-ui');

export default[
  { path: '/metadata-order', component: MetaDataOrder },
  { path: '/metadata-order/pending-review-order', component: PendingReviewOrder },
  { path: '/metadata-order/reviewed-order-list', component: ReviewedOrderList },
  { path: '/data-useApply/:id', component: DataUseApply },
  { path: '/data-useApply', component: DataUseApply },
  { path: '/data-apply-list', component: DataApplyList },
  { path: '/data-apply-detail/:id', component: DataApplyDetail },
  { path: '/order-detail/:id', component: OrderDetail },
];



// WEBPACK FOOTER //
// ./src/router/metaDataOrder.js